import api from "./api";
import { DEFAULT_TICKER_REFRESH_SECONDS } from "../constant/common";


const getCompanySettingsQuery = `query{
  settings {
    template
    defaultTab
    styleURI
    currencyEnabled
    tickerRefreshSeconds
    googleAnalyticsEnabled
    allowedParentDomains,
    enabledCalculatorAverageBased
    currencies {
      code
      text
      order
    }
    hideChart
    useLatinNumber
    instruments{
       default
       enabledDividendOption
       id
       limitInvestmentStartDate
       limitStartingData
       marketAbbreviation
       marketName
       order
       shareName
       ticker
       color
       decimalDigits
       currencyCode
    }
    format {
      shortDate
      longDate
      decimalSeparator
      thousandsSeparator
      negativeNumberFormat
      decimalDigits
      calendarDate
      positiveNumberFormat
      positiveChangeFormat
    }
    enableExcelDownload
    showDataProviderInfo
    showDataDelayInfo
    showDisclaimerInfo
    timezone
    enabledColorBlindMode
    chartVolume {
      formatXAxis {
        day
        week
        month
        quarter
        year
      }
    }
  }
  customPhrases{
    key
    value
  }
}`;

export const getCompanySettings = async () => {
  const response = await api.POST(window.appSettings.invetstmentCalApiUrl, {
    query: getCompanySettingsQuery,
  });
  response.data.settings.tickerRefreshSeconds =
    response.data.settings.tickerRefreshSeconds ?? DEFAULT_TICKER_REFRESH_SECONDS;
  return response;
};

/**
 *
 * @param {import("../..").IInstrument['instrumentId'][]} instrumentIds
 * @returns
 */
const getTickerQuery = (instrumentIds = []) => `
query {
  instruments(instrumentIds: ${JSON.stringify(instrumentIds)}){
    instrumentId,shareName,currencyCode,last,change,changePercentage,marketStatus,ticker,marketName,lastUpdatedDate, marketAbbreviation, startingDate, currency
  }
}
`;

/**
 *
 * @param {import("../..").IInstrument['instrumentId'][]} instrumentIds
 * @returns
 */
export const getTickers = (instrumentIds = []) => {
  return api.POST(window.appSettings.sDataApiUrl, {
    query: getTickerQuery(instrumentIds),
  });
};

/**
 *
 * @param {import("../..").IEntryMountShare} params
 * @returns
 */
const getAmountInvestedQuery = ({
  instrumentId,
  amountInvested,
  startDate,
  endDate,
  currency,
  dividendChecked,
  ownSharePrice = 0,
}) => `query {
  amountInvested(param: {instrumentId: ${instrumentId}, amountInvested: ${amountInvested},startDate: "${startDate}",endDate: "${endDate}", currency: "${currency}", dividendChecked: ${dividendChecked}, ownSharePrice: ${ownSharePrice}}){
    data{
      instrumentID
      initialDate
      initialPrice
      initialValue
      endDate
      endPrice
      endValue
      change
      changePro
      annualized
      shareBought
      }
      shareData{
        datas {
          date
          close
        }
        name
      }
      dividendData {
        datas {
          date
          close
        }
        name
      }
  }
 }
`;

/**
 *
 * @param {import("../..").IEntryMountShare} params
 * @returns
 */
export const getAmountInvested = params => {
  return api.POST(window.appSettings.invetstmentCalApiUrl, {
    query: getAmountInvestedQuery(params),
  });
};

const getInstrumentSharePriceQuery = ({ instrumentId, startDate, endDate, currency }) => `query {
  instrumentSharePrice(param: {instrumentId: ${instrumentId}, startDate: "${startDate}", endDate: "${endDate}", currency: "${currency}"}) {
    initialPrice
    endPrice
    initialDate
    endDate
  }
}`;

export const getInstrumentSharePrice = params =>
  api.POST(window.appSettings.invetstmentCalApiUrl, {
    query: getInstrumentSharePriceQuery(params),
  });

/**
 *
 * @param {import("../..").IEntryMountShare} params
 * @returns
 */
const getSharesPurchasedQuery = ({
  instrumentId,
  shareNumber,
  startDate,
  endDate,
  currency,
  dividendChecked,
  ownSharePrice = 0,
}) => `query {
  shareBought(param: {instrumentId: ${instrumentId}, shareNumber: ${shareNumber},startDate: "${startDate}",endDate: "${endDate}", currency: "${currency}", dividendChecked: ${dividendChecked}, ownSharePrice: ${ownSharePrice}}){
    data{ instrumentID
      initialDate
      initialPrice
      initialValue
      endDate
      endPrice
      endValue
      change
      changePro
      annualized
      shareBought
      }
      shareData{
        datas {
          date
          close
        }
        name
      }
      dividendData {
        datas {
          date
          close
        }
        name
      }
 }
 }
`;

/**
 *
 * @param {import("../..").IEntryMountShare} params
 * @returns
 */
export const getSharesPurchased = params => {
  return api.POST(window.appSettings.invetstmentCalApiUrl, {
    query: getSharesPurchasedQuery(params),
  });
};

const getCurrenciesQuery = currencies => `
  query {
    currency {
      currenciesByCodes(codes:${JSON.stringify(currencies)}){
        code
        name
      }
    }
  }
`;
/**
 *
 * @param {string[]} currencies
 * @returns {Promise<{
 *  data: {
 *    currency: {
 *      currenciesByCodes: {code: string, name: string}[]
 *    }
 * }
 * }>}
 */
export const getCurrenciesName = currencies =>
  api.POST(window.appSettings.sDataApiUrl, {
    query: getCurrenciesQuery(currencies),
  });
